import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Search from "@insite/mobius/Icons/Search";
import Link from "@insite/mobius/Link";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";
import updatePurchasedItemsConfigSelection from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/Handlers/LoadPurchasedItemsConfigHandler";
import { getPurchasedItemsConfigSelectionState } from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigSelector";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    purchasedItemsConfig: getPurchasedItemsConfigSelectionState(state),
});

const mapDispatchToProps = {
    updatePurchasedItemsConfigSelection,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface FluorochromeSearchWithinStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyPresentationProps;
    searchTextField?: TextFieldPresentationProps;
    clearSearch?: InjectableCss;
    searchQuery?: InjectableCss;
}

export const searchWithinStyles: FluorochromeSearchWithinStyles = {
    titleText: {
        variant: "h6",
        css: css`
            margin-bottom: 0px;
        `,
    },
    searchTextField: {
        // iconProps: {
        //     src: Search,
        // },
        cssOverrides: {
            formField: css`
                width: 100%;
                button:focus {
                    outline: none;
                }
                > div[class^="FormInputWrapper"] {
                    > input {
                        padding-right: 40px !important;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            `,
        },
    },
    clearSearch: {
        css: css`
            display: flex;
            margin-bottom: 14px;
            justify-content: space-between;
        `,
    },
    searchQuery: {
        css: css`
            margin-top: 12px;
            font-size: 14px;
        `,
    },
};

const styles = searchWithinStyles;

const PurchasedItemsSearchWithin: FC<Props> = ({ updatePurchasedItemsConfigSelection, purchasedItemsConfig }) => {
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        
        setSearchText(purchasedItemsConfig.Search);
    }, [purchasedItemsConfig.Search]);

    const doSearch = (val:string) => {
        // if (val.trim() !== "") {
            updatePurchasedItemsConfigSelection({
                Search: val,
                Description: purchasedItemsConfig.Description,
                fromDate:purchasedItemsConfig.fromDate,
                toDate:purchasedItemsConfig.toDate,
            });
     
        // }
    };
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            event.preventDefault();
            doSearch(event.currentTarget.value);
        } else {
            setSearchText(event.currentTarget.value);
        }
    };
    const clearSearch = () => {
        setSearchText("");
        if (purchasedItemsConfig.Search && purchasedItemsConfig.Search !== "") {
            updatePurchasedItemsConfigSelection({
                Search: "",
            });
        }
    };

    const handleChange = (event: React.FormEvent<HTMLInputElement>): void => {
        setSearchText(event.currentTarget.value);
        doSearch(event.currentTarget.value);
    };

  
    const label = translate(`Stellar Number # Or Customer Part Number`);

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.clearSearch}>
                <Typography {...styles.titleText}>{label}</Typography>
                {/* <Link onClick={() => clearSearch()}>{translate("Clear Search")}</Link> */}
            </StyledWrapper>
            <TextField
                {...styles.searchTextField}
                // iconClickableProps={{ onClick: doSearch }}
                value={searchText}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder={translate("Enter Stellar Number # Or Customer Part Number")}
                type="text"
                data-test-selector="PurchasedItemsSearchWithin"
                id="purchasedItemsKeywordSearch"
            />
            {purchasedItemsConfig.Search && purchasedItemsConfig.Search !== "" ? (
                <StyledWrapper>
                    <Typography
                        variant="p"
                        {...styles.searchQuery}
                    >{`Search Query : ${searchText} `}</Typography>
                </StyledWrapper>
            ) : null}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PurchasedItemsSearchWithin),
    definition: {
        group: "Basic",
        displayName: "Purchased Items Search Filter",
    },
};

export default widgetModule;
